import React from "react";
import CountUp from "react-countup";

const Summary = ({ profile }) => {
  const { title, count, prifex, dis } = profile;
  return (
    <div className=" my-4 text-center nav-bg5">
      <div className="  items-center text-center text-light p-3 px-lg-5  rounded-pill">
        <h4 className="card-title ">
          {title} <span className=" ps-2 text-info">{profile?.icons}</span>
        </h4>
        <h2 className=" font-bold ">
          <span>
            <CountUp end={count} />
            {prifex}
          </span>
        </h2>
        <p> {dis} </p>
      </div>
    </div>
  );
};

export default Summary;
